
import './Ujab_detail.scss';
import * as S from '../scss/theme';
import fnc from '../mymod/commFunction';
import fncS4 from '../mymod/commFunction4';
import HongButton from '../comm/HongButton';
import React, { useState, useRef, useMemo, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import HeaderTitle from '../comm/HeaderTitle';
import HongComboboxNew from '../comm/HongComboboxNew';
import JoditEditor from 'jodit-react';
import HongInput from '../comm/HongInput';
import Ujab_detail_download from './Ujab_detail_download';
import { selectedParentCode_ujab, setSelectedParentCode_ujab } from "../reduxToolkit/reduxIgong";

const Ujab_detail = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const code = useSelector(state => state.reduxIgong.selectedParentCode_ujab);
  const isAdmin = useSelector((state => state.reduxIgong.isAdmin));

  const [listUnit1, setListUnit1] = useState([]);
  const [listUnit2, setListUnit2] = useState([]);
  const [title, setTitle] = useState('알쓸우잡 상세');
  const editor = useRef(null);
  const [content, setContent] = useState(''); // JoditEditor의 내용 상태
  const [subject, setSubject] = useState(''); // 주제 입력 상태
  const [writer, setWriter] = useState('');
  const [hp, setHp] = useState('');
  const [email, setEmail] = useState('');
  const [career, setCareer] = useState('');

  const [files, setFiles] = useState({});
  const [fileNames, setFileNames] = useState({});
  const [parentCode, setParentCode] = useState(null);
  const [selectedUnit1, setSelectedUnit1] = useState(null);
  const [selectedUnit2, setSelectedUnit2] = useState(null);
  const [list, setList] = useState([]); // 게시글 목록 상태
  const [fileCnt, setFileCnt] = useState(0); // 파일 개수 상태
  

  useEffect(() => {
    fncSelect_list(code);
  }, []);


function fncSelect_list(code) {
  fnc.sendAxios('/igongUjabRoutes/select/board_detail', { code }, (res) => {
    if (res && Array.isArray(res)) {
      const newList = getRecords(res);
      setList(newList);
    } else {
      alert('검색에 실패했습니다.');
    }
  });

  function getRecords(res) {
    return res.map(item => ({
      sno: item["sno"],
      unit1_code: item["unit1_code"],
      unit2_code: item["unit2_code"],
      subject: item["subject"],
      content: item["content"],
      writer: item["writer"],
      hp: item["hp"],
      email: item["email"],
      career: item["career"],
      sDate: fnc.formatDate2(item["sDate"])
    }));
    }
  }

  useEffect(() => {
    setSubject(list.length > 0 ? list[0].subject : '');
    setContent(list.length > 0 ? list[0].content : ''); 
    setWriter(list.length > 0 ? list[0].writer : '');
    setHp(list.length > 0 ? list[0].hp : '');
    setEmail(list.length > 0 ? list[0].email : '');
    setCareer(list.length > 0 ? list[0].career : '');
  }, [list]);


// JoditEditor 설정

  const config = useMemo(
    () => ({
      readonly: true, // 읽기 전용
      toolbar: false,  // 툴바 숨김
      statusbar: false, // 상태바 숨김
      enableDragAndDropFileToEditor: false, // ✅ 파일 드래그 방지 (선택)
      style: {
        textAlign: 'left'
      }
    }),[]
  );

  
  function onUdate() {
    dispatch(setSelectedParentCode_ujab(code));
    navigate('/ujab_write');
  }

  function onDelete() {
    if (fileCnt > 0) {
      alert('파일이 존재합니다. 파일을 삭제 후 게시글을 삭제하세요.');
      return;
    }

    const rtn = window.confirm('게시글을 삭제하시겠습니까?');   
    if (!rtn) return null;

    fncDeleteBoard( code );
  }



  function fncDeleteBoard( code ) {
  
    fnc.sendAxios(`/igongUjabRoutes/delete/board_detail_all`, {code}, (res) => {
      if (res) {
        onBackClick();
      } else {
        console.log('uploadRecord 저장 중 오류');
      }
    });
  }

  function onBackClick() {
    const unit1_code = list.length > 0 ? list[0].unit1_code : '';
    const unit2_code = list.length > 0 ? list[0].unit2_code : '';
    navigate(`/ujab_board?unit1_code=${unit1_code}&unit2_code=${unit2_code}`); 
  }
    
//=========================================
  return (
    <S.Section2>
    
    <div className='Ujab_detail'>
      <section className='sec-main'>
      <HeaderTitle title={title} direction={1} onBackClick={onBackClick} />
      <article className='art-subject'>
        <div className='box-subject'>
          <HongInput
            className='input-subject'
            value={subject}
            readOnly={true}
          />
        </div>

        <span className='date'>{list.length > 0 ? list[0].sDate : ''}</span>
      </article>

      <article className='art-jodit'>
          <JoditEditor
              ref={editor}
              value={content}
              config={config}
              tabIndex={1} // 텍스트 영역의 tabIndex
              // onBlur={newContent => setQue(newContent)} // 죽여야 닫기 할 때 에러 안 남
              onChange={newContent =>setContent(newContent)}
          />
      </article>

      
      <article className='art-fileDownload'>
        <Ujab_detail_download parentCode={code} setFileCnt={setFileCnt} isVisible={false} />    
      </article>


      {isAdmin && 
        <>
          <article className='art-info'>
            <div className='box-info'>
              <label className='label-info'>작성자</label>
                <HongInput
                  className='input-info'
                  label=''
                  value={writer}
                  readOnly={true}
                />
            </div>


            <div className='box-info'>
              <label className='label-info'>연락처</label>
                <HongInput
                  className='input-info'
                  label=''
                  value={hp}
                  readOnly={true}
                />
            </div>


            <div className='box-info'>
              <label className='label-info'>email</label>
                <HongInput
                  className='input-info'
                  label=''
                  value={email}
                  readOnly={true}
                />
            </div>

              <div className='box-info'>
              <label className='label-info'>이력</label>
                <HongInput
                  className='input-info'
                  label=''
                  value={career}
                  readOnly={true}
                />
            </div>
          </article>


          <article className='art-menu'>
                <HongButton className='btn h-btn-gray' onClick={() => onBackClick()}>목록으로</HongButton>
                <HongButton className='btn h-btn-green' onClick={onUdate}>수정</HongButton>
                <HongButton className='btn h-btn-red' onClick={onDelete}>삭제</HongButton>
          </article>

      </>  }

         {!isAdmin && <article className='art-menu'>
                  <HongButton className='btn h-btn-gray' onClick={() => onBackClick()}>목록으로</HongButton>
          </article>}

    </section>
    </div>
    
    </S.Section2>

  );
};

export default Ujab_detail;